
import discussion from '@/components/discussion.vue';
export default {
name: 'gallery',
props: ['type'],
components: { discussion },
data() {
    return {
        source: {
            postsList: { },
            // worksList: {}
        },//数据
        loading: true,
        hot_type: 1,
        currentPage:1
    }
},
computed: {
    /** 帖子列表是否有可渲染数据 */
    hasListData() {
        return Array.isArray(this.source?.postsList?.data) && this.source.postsList.data.length > 0
    },
},
watch: {
    hot_type(val) {
        this.currentPage = 1
        this.type == 1 ? this.getUserInfo(val) : this.getOtherUserInfo(val)
    }
},
mounted() {
    this.type == 1 ? this.getUserInfo() : this.getOtherUserInfo()
    // this.$emit()
    // this.getUserInfoHot()
},
methods: {
    // 获取本人个人信息
    async getUserInfo(type=1,page=1) {
        this.loading = true
        let res = await this.$global.userInfoDiscussion({ "page": page, "order_type": type ,'page_num':20 })
        this.source = res.code === 200 ? res.data : { postsList: { data: [], total: 0 } }
        this.loading = false
    },
    // 页码
    handleCurrentChange(val) {
            this.currentPage = val
            this.type == 1 ? this.getUserInfo(this.hot_type, val) : this.getOtherUserInfo(this.hot_type, val)
    },
    // 获取他人个人帖子
    async getOtherUserInfo(type=1,page=1) {
        this.loading = true
        let res = await this.$global.otherUserPost({ "page": page, "order_type": type, user_id: this.$route.params.id,'page_num':20  })
        this.source = res.code === 200 ? res.data : { postsList: { data: [], total: 0 } }
        this.loading = false
    },
}
}
